import React from 'react'
import { constants } from 'common/helpers'

import composeDialogModal from 'components/modals/DialogModal/composeDialogModal'

import messages from './messages'


const ChangesSaveSuccessModal = composeDialogModal({
  name: constants.modals.ChangesSaveSuccess,
  contentMessage: messages.text,
})

export default ChangesSaveSuccessModal
